// Sentinel stored in Redux `state.connector.errMsg` instead of a raw error string —
// keeps URLs/IDs out of RUM snapshots. Raw errors go to Datadog via sendLog.
export const CONNECTOR_LOAD_ERROR = 'load_error';
